webpackJsonp([236347314162643],{

/***/ 329:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"username":"ekug","fullname":"Ekansh Gupta"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---submissions-56c1a5b2886523856f2c.js